import { jsx as _jsx } from "react/jsx-runtime";
export function AdminLogo() {
    return (_jsx("img", { style: { height: "100%", objectFit: "contain" }, src: "/public/logo.png" }, void 0));
}
